import { styleReset } from 'react95';
import theSixtiesUSA from "react95/dist/themes/theSixtiesUSA";
import styled, { css, createGlobalStyle, ThemeProvider, keyframes } from 'styled-components';
import { wobble } from 'react-animations';
import ms_sans_serif from "react95/dist/fonts/ms_sans_serif.woff2";
import ms_sans_serif_bold from "react95/dist/fonts/ms_sans_serif_bold.woff2";
import img from "./assets/background.webp";
import Footer from "./footer"
import Window from "./window"
import NavBar from "./navbar"

const wobbleAnim = keyframes`${wobble}`;

const GlobalStyles = createGlobalStyle`
  @font-fact {
    font-family: 'ms_sans_serif';
    src: url('${ms_sans_serif}') format('woff2');
    font-weight: 400;
    font-style: normal
  }
  @font-face {
    font-family: 'ms_sans_serif'
    src: url('${ms_sans_serif_bold}') format('woff2');
    font-weight: bold;
    font-style: normal
  }
  body {
    font-family: 'ms_sans_serif';
    background: url(${img});
    background-repeat: no-repeat;
    background-size: cover;
    margin: 0;
    padding: 0;
  }
  html {
    height: 100%;
  }
  ${styleReset}
`;

const Wrapper = styled.div`
  align-items: 'center';
  justify-content: 'center';
  text-align: 'center';
  animation: 1 10s ${wobbleAnim};
  max-width: 600px;
  padding: 10px;
  margin: 50px auto 50px;
`;

function App() {
  return (
    <div>
      <GlobalStyles />
      <ThemeProvider theme={theSixtiesUSA}>
				<NavBar />
        <Wrapper>
					<center>
						<Window />
					</center>
        </Wrapper>
        <Footer />
			</ThemeProvider>
    </div>
  );
}

export default App;
